import React from 'react';
import { ArrowUpRight, BarChart3, LayoutDashboard, Trophy, Users } from 'lucide-react';
import { useI18n } from '../../../i18n';
import './appScreenShowcase.css';

const EMPTY_IMAGE = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="1" height="1"/%3E';
const SCREENS = [
  { name: 'results', width: 1440, height: 900, crop: [70, 24, 1300, 540], title: 'Moje wyniki', Icon: LayoutDashboard, color: '#80dfaf', detail: { name: 'results-mobile', width: 390, height: 1222, crop: [10, 22, 370, 780], phone: true } },
  { name: 'statistics', width: 1440, height: 1890, crop: [360, 390, 1010, 690], title: 'Statystyki', Icon: BarChart3, color: '#89b9f1', detail: { name: 'statistics', width: 1440, height: 1890, crop: [390, 1430, 960, 220] } },
  { name: 'ranking', width: 1440, height: 1926, crop: [180, 24, 1080, 710], title: 'Tablica wyników', Icon: Trophy, color: '#e9c480', detail: { name: 'ranking', width: 1440, height: 1926, crop: [192, 1025, 1056, 94] } },
  { name: 'friends', width: 1440, height: 900, crop: [180, 24, 1080, 650], title: 'Znajomi', Icon: Users, color: '#b4a1ee', detail: { name: 'profile-mobile', width: 390, height: 2920, crop: [10, 10, 370, 780], phone: true } },
];

// Cropping and framing happen in CSS; the original application captures stay intact.
function ScreenCrop({ screen }) {
  const [x, y, width, height] = screen.crop;
  return (
    <div className="login-screen-crop" style={{ aspectRatio: `${width} / ${height}` }}>
      <picture>
        <source media="(min-width: 1024px)" srcSet={`/screenshots/login/${screen.name}.png`} />
        <img src={EMPTY_IMAGE} alt="" loading="lazy" decoding="async" width={screen.width} height={screen.height}
          style={{ width: `${screen.width / width * 100}%`, left: `${-x / width * 100}%`, top: `${-y / height * 100}%` }} />
      </picture>
    </div>
  );
}

export default function AppScreenShowcase({ index }) {
  const { t } = useI18n();
  const screen = SCREENS[index];
  if (!screen) return null;
  const { Icon } = screen;
  return (
    <figure className={`login-screen-showcase login-screen-showcase--${index}`} style={{ '--screen-accent': screen.color }} aria-label={t(screen.title)}>
      <div className="login-screen-orbit" aria-hidden="true" />
      <div className="login-screen-window">
        <div className="login-screen-chrome" aria-hidden="true"><span><i/><i/><i/></span><b>MYKART <span>/ {String(index + 1).padStart(2, '0')}</span></b><Icon size={13}/></div>
        <ScreenCrop screen={screen} />
      </div>
      <div className={`login-screen-detail${screen.detail.phone ? ' login-screen-detail--phone' : ''}`} aria-hidden="true">
        {screen.detail.phone && <div className="login-screen-speaker" />}
        <ScreenCrop screen={screen.detail}/>
      </div>
      <figcaption><span><Icon size={14}/>{t(screen.title)}</span><ArrowUpRight size={14}/><small>{t('loginShowcase.example')}</small></figcaption>
    </figure>
  );
}
